<template>
  <button
    type="button"
    :class="[
      btnClass,
      'preika-save-button',
      `preika-save-button--${resolvedActionKind}`
    ]"
    :data-action-kind="resolvedActionKind"
    :disabled="loading || disabled"
    :aria-busy="loading ? 'true' : 'false'"
    :aria-label="displayLabel"
    @click="$emit('click', $event)"
  >
    <span v-if="loading" class="my-spinner" aria-hidden="true"></span>
    <span class="preika-save-button__label">{{ displayLabel }}</span>
  </button>
</template>

<script>
export default {
  name: 'SaveButton',

  props: {
    label: {
      type: String,
      default: '送信'
    },
    loadingLabel: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    btnClass: {
      type: String,
      default: 'btn btn-primary'
    },
    actionKind: {
      type: String,
      default: ''
    }
  },

  computed: {
    displayLabel () {
      if (!this.loading) return this.label
      if (this.loadingLabel) return this.loadingLabel

      const normalized = String(this.label || '').replace(/\s+/g, '')
      const candidates = [
        ['保存', '保存中'],
        ['登録', '登録中'],
        ['更新', '更新中'],
        ['申請', '申請中'],
        ['承認', '承認中'],
        ['差戻', '処理中'],
        ['削除', '削除中'],
        ['取消', '取消中'],
        ['送信', '送信中'],
        ['検索', '検索中'],
        ['表示', '読込中'],
        ['出力', '出力中']
      ]
      const matched = candidates.find(([word]) => normalized.includes(word))
      return matched ? matched[1] : '処理中'
    },

    resolvedActionKind () {
      const requested = String(this.actionKind || '').trim().toLowerCase()
      if (['primary', 'secondary', 'success', 'warning', 'danger', 'info'].includes(requested)) {
        return requested
      }

      const classes = String(this.btnClass || '')
      if (/\bbtn-danger\b/.test(classes)) return 'danger'
      if (/\bbtn-warning\b/.test(classes)) return 'warning'
      if (/\bbtn-success\b/.test(classes)) return 'success'
      if (/\bbtn-secondary\b/.test(classes)) return 'secondary'
      if (/\bbtn-info\b/.test(classes)) return 'info'

      const normalized = String(this.label || '').replace(/\s+/g, '')
      if (/(削除|取消|除外|無効)/.test(normalized)) return 'danger'
      if (/(差戻|却下|注意)/.test(normalized)) return 'warning'
      if (/(承認|完了)/.test(normalized)) return 'success'
      if (/(戻る|閉じる|キャンセル)/.test(normalized)) return 'secondary'

      return 'primary'
    }
  }
}
</script>
